import { useMemo } from "react";
import { useObjectFlagValue } from "@openfeature/react-sdk";
import flags from "../features/featureFlags/flags";

const DEFAULT_PORTAL_URL = import.meta.env.VITE_PORTAL_URL || "https://portal.tg.org.au";

export function usePortal() {
  const shouldUseFlagsmith = import.meta.env.REACT_APP_FLAG_PROVIDER === "flagsmith";
  const defaultPortalConfig = shouldUseFlagsmith
    ? null
    : {
        portalUrl: DEFAULT_PORTAL_URL,
      };

  const portalConfig = useObjectFlagValue(flags.PORTAL_ENABLED, defaultPortalConfig);

  const isPortalEnabled = useMemo(() => {
    if (!portalConfig || typeof portalConfig !== "object") {
      return false;
    }

    if (typeof portalConfig.enabled === "boolean") {
      return portalConfig.enabled;
    }

    return typeof portalConfig.portalUrl === "string" && portalConfig.portalUrl.trim().length > 0;
  }, [portalConfig]);

  const portalUrl = useMemo(() => {
    const configuredUrl = portalConfig?.portalUrl;
    if (typeof configuredUrl === "string" && configuredUrl.trim().length > 0) {
      return configuredUrl;
    }
    return DEFAULT_PORTAL_URL;
  }, [portalConfig]);

  return {
    isPortalEnabled,
    portalUrl,
  };
}
